import { AuthorizationModalProps } from "./types";
import {
  HStack,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  View
} from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { Icon } from "@repo/core/components/core/Icon";
import { Modal } from "@repo/core/components/layout/Modal";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { ForwardedRef, forwardRef } from "react";
import { useAuthorizationModalController } from "./controller";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import { KeyboardAvoidingView } from "@repo/core/components/core/KeyboardAvoidingView";

export const AuthorizationModal = forwardRef(function Drawer(
  { title, onClose, onConfirm, isLoading }: AuthorizationModalProps,
  ref: ForwardedRef<IModalRefProps>
) {
  const { control, isMobile, onSubmit, isValid } =
    useAuthorizationModalController({
      onConfirm
    });
  return (
    <KeyboardAvoidingView>
      <Modal ref={ref}>
        <ModalHeader justifyContent="space-between">
          <Text
            fontWeight={700}
            family="roboto"
            fontSize="$xl"
            color="$backgroundLight900"
          >
            {title}
          </Text>
          <ModalCloseButton>
            <Icon name="times" size="xs" />
          </ModalCloseButton>
        </ModalHeader>
        <ModalBody py="$6">
          <View gap="$4">
            <InputControlled
              control={control}
              name="strUsuario"
              placeholder="Digite seu usuário"
              size="md"
              returnKeyType="next"
              label="Usuário"
              isRequired
              bgColor="$backgroundLight100"
            />

            <InputControlled
              control={control}
              name="strSenha"
              placeholder="Digite sua senha"
              size="md"
              label="Senha"
              isRequired
              secureTextEntry
              bgColor="$backgroundLight100"
            />
          </View>
        </ModalBody>
        <ModalFooter>
          <HStack
            gap="$3"
            width="$full"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
          >
            <Button
              size="lg"
              flex={isMobile ? undefined : 1}
              width="$full"
              variant="outline"
              action="negative"
              text="Cancelar"
              onPress={onClose}
              disabled={isLoading}
            />
            <Button
              size="lg"
              flex={isMobile ? undefined : 1}
              width="$full"
              variant="solid"
              action="primary"
              text="Autorizar"
              isDisabled={!isValid}
              onPress={onSubmit}
              isLoading={isLoading}
            />
          </HStack>
        </ModalFooter>
      </Modal>
    </KeyboardAvoidingView>
  );
});
